<template>
  <div class="BasicSettings">

    <h1>Basiseistellungen Event</h1>

    <form @submit.prevent="saveBereich">

      <div class="field">
        <label class="label">Bereiche Erstellen</label>

        <div class="control">
          <input
            class="input"
            type="text"
            placeholder="Bereich"
            v-model="bereich"
            required
          >
          <input
            class="input"
            type="text"
            placeholder="Beschreibung"
            v-model="bereichBeschreibung"
            required
          >
        </div>
      </div>
      <div class="field">
        <div class="control">
          <button
            type="submit"
            class="button is-link"
          >Submit</button>
        </div>
      </div>

    </form>
    <div
      v-for="sBereich in orderBy(schichtBereich, 'bereich' )"
      :key="sBereich.id"
    >
      <div class="columns">
        <div class="column is-8">
          <p class="user-list__header">{{sBereich.id}}</p>
          <p class="user-list__header">{{sBereich.beschreibung}}</p>
          <button
            class="button is-danger"
            v-on:click="deleteBereich(sBereich)"
          >Löschen</button>
        </div>
      </div>
    </div>

    <form @submit.prevent="saveZeiten">

      <div class="field">
        <label class="label">Schicht Zeiten Erfassen</label>
        <div class="control">

          <!-- <input class="input" type="text" placeholder="schichtZeit" v-model="schichtZeit" required> -->
          <flat-pickr
            class="input "
            v-model="schichtZeitA"
            :config="config"
            placeholder="Startzeit"
          ></flat-pickr>
          <flat-pickr
            class="input "
            v-model="schichtZeitB"
            :config="config"
            placeholder="Endzeit"
          ></flat-pickr>
        </div>
      </div>

      <div class="field">
        <div class="control">
          <button
            type="submit"
            class="button is-link"
          >Submit</button>
        </div>
      </div>

    </form>

    <div
      v-for="sZeit in schichtZeiten"
      :key="sZeit.id"
    >
      <div class="columns">
        <div class="column is-8">
          <p class="user-list__header">{{sZeit.schichtZeit}}</p>
          <button
            class="button is-danger"
            v-on:click="deleteZeit(sZeit)"
          >Löschen</button>

        </div>
      </div>
    </div>

    <form @submit.prevent="saveFestivalTage">

      <div class="field">
        <label class="label">Festivaltage erfassen</label>
        <div class="control">
          <flat-pickr
            class="input "
            v-model="festivalTag"
            :config="config2"
            placeholder="Festival Tag"
          ></flat-pickr>
          <!-- <input class="input" type="text" placeholder="festivalTag" v-model="festivalTag" required> -->
        </div>
      </div>

      <div class="field">
        <div class="control">
          <button
            type="submit"
            class="button is-link"
          >Submit</button>
        </div>
      </div>

    </form>

    <div
      v-for="fTag in festivalTage"
      :key="fTag.id"
    >
      <div class="columns">
        <div class="column is-8">
          <p class="user-list__header">{{fTag.festivalTag}}</p>
          <button
            class="button is-danger"
            v-on:click="deleteFestivalTag(fTag)"
          >Löschen</button>

        </div>
      </div>
    </div>
    <br>
    <br>
    <!-- Anmeldung sperren -->
    <div class="field">
      <label class="label">Anmeldung sperren oder freigeben</label>
      <button
        class="button is-success"
        v-if="!checkAnmeldeFenster() "
        v-on:click="freigeben()"
      >Freigeben</button>
      <button
        class="button is-danger"
        v-if="checkAnmeldeFenster()"
        v-on:click="sperren()"
      >Sperren</button>
    </div>

    <br>
    <br>
    <!-- List all Admin Users -->
    <form @submit.prevent="saveIsAdmin">

      <div class="field">
        <label class="label">Admin erstellen</label>

        <div class="control">
          <input
            class="input"
            type="text"
            placeholder="adminEmail"
            v-model="adminEmail"
            required
          >

        </div>
      </div>
      <div class="field">
        <div class="control">
          <button
            type="submit"
            class="button is-link"
          >Submit</button>
        </div>
      </div>

    </form>

    <div
      v-for="adminUser in adminUsers"
      :key="adminUser.id"
    >
      <div class="columns">
        <div class="column is-8">

          <p class="user-list__header">
            <strong>Name</strong>: {{adminUser.name}}</p>
          <div class="inner">
            <div class="left">
              <p class="user-list__sub">
                <strong>Email</strong>: {{adminUser.email}}</p>
            </div>

          </div>
          <button
            class="button is-danger"
            v-on:click="deleteAdmin(adminUser)"
          >Löschen</button>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import firebase from 'firebase'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import Moment from 'moment'


Vue.use(Vue2Filters)

export default {
  name: 'BasicSettings',
  mixins: [Vue2Filters.mixin],

  data () {
    return {
      anmeldefenster: Boolean,
      schichtBereich: [],
      festivalTage: [],
      schichtZeiten: [],
      bereich: null,
      bereichBeschreibung: null,
      schichtZeit: null,
      festivalTag: null,
      schichtZeitA: null,
      schichtZeitB: null,
      adminEmail: null,
      adminUsers: [],
      config: {
        enableTime: true,
        noCalendar: true,
        time_24hr: true
      },
      config2: {
        enableTime: false,
        noCalendar: false,
        dateFormat: 'd.m.Y'

      }

    }
  },
  components: {
    flatPickr
  },

  created () {
    this.checkAnmeldeFenster()
    this.getEventBasicsSchichten()

    this.getEventBasicsZeiten()

    this.getEventBasicsTage()
    this.getAdminUsers()
  },

  methods: {
    getEventBasicsSchichten () {
      firebase
        .firestore()
        .collection('EventBasicsSchichten')
        .get()
        .then(querySnapshot => {
          const schichtBereich = []
          this.loading = false
          querySnapshot.forEach(doc => {
            let data = {
              id: doc.id,
              bereich: doc.data().bereich,
              beschreibung: doc.data().beschreibung
            }
            schichtBereich.push(data)
          })
          this.schichtBereich = schichtBereich
        })
    },

    getEventBasicsZeiten () {
      firebase
        .firestore()
        .collection('EventBasicsZeiten')
        .get()
        .then(querySnapshot => {
          const schichtZeiten = []
          this.loading = false
          querySnapshot.forEach(doc => {
            let data = {
              id: doc.id,
              schichtZeit: doc.data().schichtZeit
            }
            schichtZeiten.push(data)
          })
          this.schichtZeiten = schichtZeiten
        })
    },

    getEventBasicsTage () {
      firebase
        .firestore()
        .collection('EventBasicsTage')
        .get()
        .then(querySnapshot => {
          const festivalTage = []
          this.loading = false
          querySnapshot.forEach(doc => {
            let data = {
              id: doc.id,
              festivalTag: doc.data().festivalTag
            }
            festivalTage.push(data)
          })
          this.festivalTage = festivalTage
        })
    },
    getAdminUsers () {
      firebase
        .firestore()
        .collection('users')
        .where("admin", "==", true)
        .get()
        .then(querySnapshot => {
          const adminUsers = []
          this.loading = false
          querySnapshot.forEach(doc => {
            let data = {
              admin: doc.data().admin,
              email: doc.data().email,
              name: doc.data().displayName,
              uid: doc.data().userID
            }
            adminUsers.push(data)

          })
          this.adminUsers = adminUsers

        })

    },

    saveBereich () {
      if (!this.bereich || !this.bereichBeschreibung) {
        alert('Upps die Felder dürfen nicht leer sein')
        return
      }
      firebase
        .firestore()
        .doc('EventBasicsSchichten/' + this.bereich)
        .set({
          bereich: this.bereich,
          beschreibung: this.bereichBeschreibung
        })
        .then(this.getEventBasicsSchichten)
      alert('bereich gespeichert')
    },
    // saveZeiten () {
    //   // if (this.schichtZeitA > this.schichtZeitB || !this.schichtZeitA || !this.schichtZeitB) {
    //   //   alert('Upps checke deine Zeiten')
    //   //   return
    //   // }
    //   firebase
    //     .firestore()
    //     .doc('EventBasicsZeiten/' + this.schichtZeitA + ' - ' + this.schichtZeitB)
    //     .set({
    //       schichtZeit: this.schichtZeitA + ' - ' + this.schichtZeitB
    //     })
    //     .then(this.getEventBasicsZeiten)
    //   alert('Zeit gespeichert')
    // },
    saveZeiten () {
      var start = Moment(this.schichtZeitA, 'HH.mm')
      var stop = Moment(this.schichtZeitB, 'HH.mm')
      if (this.schichtZeitA > this.schichtZeitB || !this.schichtZeitA || !this.schichtZeitB) {
        var r = confirm('Upps checke deine Zeiten. Wenn deine Schicht länger als Mitternacht dauert, drücke OK. Ansonsten ABBRECHEN')
        if (r === true) {
          // var start = Moment(this.schichtZeitA, 'HH.mm')
          // var stop = Moment(this.schichtZeitB, 'HH.mm')
          if (stop.diff(start, 'h') > 0) {
            let dauer = stop.diff(start, 'h')
            firebase
              .firestore()
              .doc('EventBasicsZeiten/' + this.schichtZeitA + ' - ' + this.schichtZeitB)
              .set({
                schichtZeit: this.schichtZeitA + ' - ' + this.schichtZeitB,
                schichtDauer: dauer
              })
              .then(this.getEventBasicsZeiten)
            alert('Zeit gespeichert')
          } else {
            let dauer = 24 + stop.diff(start, 'h')
            firebase
              .firestore()
              .doc('EventBasicsZeiten/' + this.schichtZeitA + ' - ' + this.schichtZeitB)
              .set({
                schichtZeit: this.schichtZeitA + ' - ' + this.schichtZeitB,
                schichtDauer: dauer
              })
              .then(this.getEventBasicsZeiten)
            alert('Zeit gespeichert')
          }
        }
        // else {}
      } else {
        // var start = Moment(this.schichtZeitA, 'HH.mm')
        // var stop = Moment(this.schichtZeitB, 'HH.mm')
        if (stop.diff(start, 'h') > 0) {
          let dauer = stop.diff(start, 'h')
          firebase
            .firestore()
            .doc('EventBasicsZeiten/' + this.schichtZeitA + ' - ' + this.schichtZeitB)
            .set({
              schichtZeit: this.schichtZeitA + ' - ' + this.schichtZeitB,
              schichtDauer: dauer
            })
            .then(this.getEventBasicsZeiten)
          alert('Zeit gespeichert')
        } else {
          let dauer = 24 + stop.diff(start, 'h')
          firebase
            .firestore()
            .doc('EventBasicsZeiten/' + this.schichtZeitA + ' - ' + this.schichtZeitB)
            .set({
              schichtZeit: this.schichtZeitA + ' - ' + this.schichtZeitB,
              schichtDauer: dauer
            })
            .then(this.getEventBasicsZeiten)
          alert('Zeit gespeichert')
        }
      }
    },

    saveFestivalTage () {
      firebase
        .firestore()
        .doc('EventBasicsTage/' + this.festivalTag)
        .set({
          festivalTag: this.festivalTag
        })
        .then(this.getEventBasicsTage)
      alert('Tag gespeichert')
    },
    saveIsAdmin () {

      firebase
        .firestore()
        .collection('users')
        .where("email", "==", this.adminEmail)
        .get()
        .then(querySnapshot => {
          if (querySnapshot.empty === false) {
            // eslint-disable-next-line no-console
            console.log(querySnapshot.empty)
            this.loading = false
            querySnapshot.forEach(doc => {

              let setAdminUid = doc.data().userID
              // this.adminUsers.push(data)
              // eslint-disable-next-line no-console
              console.log(setAdminUid)
              firebase
                .firestore()
                .collection('users')
                .doc(setAdminUid)
                .update({ admin: true })
                .then(this.getAdminUsers)

            })
          } else {

            alert('Diese Mailadresse existiert nicht')          }
        })
    },

    checkAnmeldeFenster () {


      firebase
        .firestore()
        .collection('basics')
        .get()
        .then(querySnapshot => {
          this.loading = false
          querySnapshot.forEach(doc => {
            let data = doc.data().offen


            this.anmeldefenster = data
          })

        })
      if (this.anmeldefenster === true) { return true } else { return false }





    },

    sperren () {
      firebase
        .firestore()
        .collection('basics')
        .doc('settings')
        .update({ offen: false })
        .then(this.checkAnmeldeFenster)

    },

    freigeben () {
      firebase
        .firestore()
        .collection('basics')
        .doc('settings')
        .update({ offen: true })
        .then(this.checkAnmeldeFenster)

    },

    deleteBereich (sBereich) {
      firebase
        .firestore()
        .collection('EventBasicsSchichten')
        .doc(sBereich.id)
        .delete()
        .then(this.getEventBasicsSchichten)
    },

    deleteZeit (sZeit) {
      firebase
        .firestore()
        .collection('EventBasicsZeiten')
        .doc(sZeit.id)
        .delete()
        .then(this.getEventBasicsZeiten)
    },

    deleteFestivalTag (fTag) {
      firebase
        .firestore()
        .collection('EventBasicsTage')
        .doc(fTag.id)
        .delete()
        .then(this.getEventBasicsTage)
    },
    deleteAdmin (adminUser) {


      firebase
        .firestore()
        .collection('users')
        .doc(adminUser.uid)
        .update({ admin: false })
        .then(this.getAdminUsers)
    }

  }
  // prevent unauthenticated users from accessing the admin area
  // and direct them to the login page
  // beforeRouteEnter (to, from, next) {
  //   // get the current logged in user
  //   firebase.auth().onAuthStateChanged(user => {
  //     if (user.email === 'moeruw@gmail.com') {
  //       // continue to /admin
  //       next()
  //     } else {
  //       // redirect to /login
  //       next('/hello')
  //     }
  //   })
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
